import { z } from 'zod'

import { PathField } from 'shared/api/requests/easyBuilder/pathFields'
import { EasyBuilderConfigFormSectionType } from 'shared/api/requests/easyBuilder/viewSectionTypes'

export const viewSectionFormTriggersSchema = z.object({
  displayType: z.literal(EasyBuilderConfigFormSectionType.MULTI_TRIGGERS),
  path: z.object({
    triggerCgt: z.literal(PathField.TR_CGT_ACTIVE),
    mediaSelect: z.literal(PathField.POST_COVERED_AREA),
    mediaId: z.literal(PathField.POST_ID),

    publicReplyEnabled: z.literal(PathField.PUBLIC_REPLY_ENABLED),
    publicReplyMessages: z.literal(PathField.PUBLIC_REPLY_MESSAGES),

    triggerSr: z.literal(PathField.TR_SR_ACTIVE),
    storySelect: z.literal(PathField.STORY_SELECT),
    storyId: z.literal(PathField.STORY_ID),

    automaticallyLikeReplies: z.literal(PathField.AUTOMATICALLY_LIKE_REPLIES),

    triggerDm: z.literal(PathField.TR_DM_ACTIVE),
    keywordCondition: z.literal(PathField.COMPONENT_CONDITION),
  }),
})
